import { Image, Article, Section, SectionHeader, DocsHeader, DocsHeading, DocsIntro } from '../extra/Components';


import visaMaterial from '../assets/2 utrustning/1 intro/1 visaMaterial.jpg'
import visaMaterialSmall from '../assets/2 utrustning/1 intro/1 visaMaterial-small.jpg'
import utrustningIFrifall from '../assets/2 utrustning/2 kringutrusning/2 utrustning i frifall labels.png'
import utrustningIFrifallSmall from '../assets/2 utrustning/2 kringutrusning/2 utrustning i frifall labels-small.jpg'
import utrustningIPlanet from '../assets/2 utrustning/3 rigg/3 utrustning i planet labels.png'
import utrustningIPlanetSmall from '../assets/2 utrustning/3 rigg/3 utrustning i planet labels-small.jpg'
import riggIFrifall from '../assets/2 utrustning/3 rigg/7 riggfrifall-labels.png'
import riggIFrifallSmall from '../assets/2 utrustning/3 rigg/7 riggfrifall-labels-small.jpg'
import bagOchPilot from '../assets/2 utrustning/3 rigg/4 bag och pilot labels.png'
import bagOchPilotSmall from '../assets/2 utrustning/3 rigg/4 bag och pilot labels-small.jpg'
import huvudflik from '../assets/2 utrustning/3 rigg/huvudflik.jpg'
import huvudflikSmall from '../assets/2 utrustning/3 rigg/huvudflik-small.jpg'
import bagGummiBand from '../assets/2 utrustning/3 rigg/bagGummiband.jpg'
import bagGummiBandSmall from '../assets/2 utrustning/3 rigg/bagGummiband-small.jpg'
import orangeLapp from '../assets/2 utrustning/3 rigg/orangeLapp.jpg'
import orangeLappSmall from '../assets/2 utrustning/3 rigg/orangeLapp-small.jpg'
import fallskarm from '../assets/2 utrustning/4 fallskärm/5 fallskärm labels.png'
import fallskarmSmall from '../assets/2 utrustning/4 fallskärm/5 fallskärm labels-small.jpg'
import utlösningsförlopp from '../assets/2 utrustning/4 fallskärm/6 skärm i utlösningsförlopp labels.png'
import utlösningsförloppSmall from '../assets/2 utrustning/4 fallskärm/6 skärm i utlösningsförlopp labels-small.jpg'
import lapp from '../assets/2 utrustning/4 fallskärm/7 lapp.jpg'
import lappSmall from '../assets/2 utrustning/4 fallskärm/7 lapp-small.jpg'
import varningslapp from '../assets/2 utrustning/4 fallskärm/8 varningslapp-small.jpg'
import varningslappSmall from '../assets/2 utrustning/4 fallskärm/8 varningslapp-small.jpg'
import trering3 from '../assets/2 utrustning/5 trering/trering 3-labels.png'
import trering3Small from '../assets/2 utrustning/5 trering/trering 3-labels-small.jpg'
import trering2 from '../assets/2 utrustning/5 trering/trering 2-labels.jpg'
import trering2Small from '../assets/2 utrustning/5 trering/trering 2-labels-small.jpg'
import reservIfreebag from '../assets/2 utrustning/6 reserv/1 reservIfreebag.jpg'
import reservIfreebagSmall from '../assets/2 utrustning/6 reserv/1 reservIfreebag-small.jpg'
import reservPilot from '../assets/2 utrustning/6 reserv/fjäderpilot.jpg'
import reservPilotSmall from '../assets/2 utrustning/6 reserv/fjäderpilot-small.jpg'
import reservSprint from '../assets/2 utrustning/6 reserv/reservsrpint.jpg'
import reservSprintSmall from '../assets/2 utrustning/6 reserv/reservsrpint-small.jpg'
import mergedLabel from '../assets/2 utrustning/7 aad/merged-label.jpg'
import mergedLabelSmall from '../assets/2 utrustning/7 aad/merged-label-small.jpg'
import trering from '../assets/2 utrustning/8 rsl/8 trering-labels.png'
import treringSmall from '../assets/2 utrustning/8 rsl/8 trering-labels-small.jpg'
import frifall from '../assets/2 utrustning/10 bröstrem/4 frifall.png'
import frifallSmall from '../assets/2 utrustning/10 bröstrem/4 frifall-small.jpg'
import brostrem from '../assets/2 utrustning/10 bröstrem/0 trä bröstrem.png'
import brostremSmall from '../assets/2 utrustning/10 bröstrem/0 trä bröstrem-small.jpg'
import feltradd from '../assets/2 utrustning/10 bröstrem/3 felträdd.jpg'
import feltraddSmall from '../assets/2 utrustning/10 bröstrem/3 felträdd-small.jpg'
import lossa from '../assets/2 utrustning/11 styrhandtag/lossa.jpg'
import lossaSmall from '../assets/2 utrustning/11 styrhandtag/lossa-small.jpg'
import satta from '../assets/2 utrustning/11 styrhandtag/sätta.jpg'
import sattaSmall from '../assets/2 utrustning/11 styrhandtag/sätta-small.jpg'
import elevriggar from '../assets/2 utrustning/9 elevsystem/elevRiggar.jpg'
import elevriggarSmall from '../assets/2 utrustning/9 elevsystem/elevRiggar-small.jpg'
import { Question, Questionary } from '../extra/Quiz';

import {
    faTools,
} from "@fortawesome/free-solid-svg-icons";

const materialQuiz = [
                    
                    Question.oneQ("Hur länge är en reservpackning luftvärdig?", "Sex månader", ["En månad", "Ett år", "Ett hopp", "3 månader"]),
                    Question.oneQ("Vad gör RSL-en om huvudfallskärmen är kvar i riggen?", "Inget", ["Löser ut reserven", "Gör det lättare att dra reserven", "Gör det lättare att kutta"]),
                    Question.oneQ("Vad är den totala maxtiden en reservpackning kan vara giltig med kontroller?", "Ett år", ["6 månader", "9 månader", "2 år", "för evigt"]),
                    Question.oneQ("Vem får göra halvårskontroll på reserv?", "Fallskärmskontrollant", ["Jag själv", "Annan hoppare", "Hoppare med packcert"]),
                    Question.oneQ("Vem får packa en reserv?", "Fallskärmskontrollant", ["Jag själv", "Annan hoppare", "Hoppare med packcert"]),
                    Question.qManyA("Vem får packa en fallskärm?", ["Fallskärmspackare", "Fallskärmskontrollant", "Vem som helst med kontroller utav fallskärmspackare", "Jag själv om det är min egen och jag genomfört steg ett av packarutbildning"], ["Elev som går kurs, utan kontroller", "Person med minst a-cert, utan kontroller"]),
                    Question.oneQ("Vad är sliderns syfte?", "Bromsa utlösningsförloppet av fallskärmen", ["Accelerera utlösningsförloppet", "Kontrollera linorna i utlösningsförloppet", "Signalera när fallskärmen är redo"]),
                    Question.oneQ("Vem ansvarar för att fallskärmen blir packad efter ett hopp?", "Jag själv", ["Instruktörerna", "Den som packar skärmar för dagen"]),
                    Question.oneQ("Ingår packning utav fallskärm i kurspriset?", "Nej", ["Ja", "Om jag frågar snällt"]),
                    Question.oneQ("Om jag väger 80 kg naken bör jag hoppa en elevfallskärm på minst?", "260", ["240", "280", "300"]),
                    Question.oneQ("Om AADn löser ut så får jag hoppa igen efter?", "psykologisk utvärdering", ["En vecka", "Ett år", "efter CIs godkännande", "Efter jag förklarat vad som hände"]),
                    Question.oneQ("Bröstremmen trär man", "Genom spännet runt metallbiten genom spännet igen", ["Genom spännet en gång", "Trär aldrig ur spännet."]),
                    Question.oneQ("Man trär ur benremmarna för att", "Man trär inte ur benremmarna", ["Ta på sig riggen", "Underhålla spännena", "Skjustera storlek"]),
                    Question.qManyA("I en självkontroll kollar jag?", ["Tre remmar", "Tre handtag", "Hjälm, goggles och höjdmätare"], ["Skor, ankelstöd och strumpor", "Jag, ena instruktör och andra instruktör"]),
                    Question.qManyA("Var kan man ser hur stor en fallskärm är?", ["På varningslappen på fallskärmen", "På orangea lappen"], ["Under reservfliken", "På riggen", "Under huvudskärmsfliken"]),
                    Question.oneQ("Genomför jag ett reservdrag måste jag fylla i och lämna in en:", "Gul rapport", ["Röd rapport", "Blå rapport", "Vit rapport", "Sms till CI"]),
                    Question.oneQ("Är jag nära att kollidera med någon i landning så är det bra att fylla i en: ", "Blå rapport", ["Röd rapport", "Vit rapport", "Sms till CI"]),
                    Question.oneQ("Hur länge är en huvudskärmspackning okej?", "Sex månader", ["En månad", "Ett år", "Ett hopp", "3 månader"]),
                    Question.oneQ("Om man start en cypress i planet på 1000 m på vilken höjd kommer den lösa ut i frifall?", "1225 m", ["225 m", "1000 m", "1450 m"]),
                    
                ];

const Material = ({setSection, setArticle}) => 
    (
    <Article id="utrustning" icon={faTools} name="Utrustning och material" setArticle={setArticle} setSection={setSection}>
        <DocsHeader >
            <DocsHeading note="Updaterad: 2022-07-13">Utrustning</DocsHeading>
            <DocsIntro>
                {/** <!--  TODO byt bild till faktisk bild på utrustningen. --> **/}
                <Image image={visaMaterial} imageSmall={visaMaterialSmall} alt="Fallskärmar i luften" />

                <br /><br />
                <p>Detta kapitel kommer börja med att gå
                    igenom runt-i-kring saker som exempelvis hjälm, höjdmätare och klädsel. Därefter går vi
                    djupare in på hur själva
                    fallskärmen ser ut. I utbildningen ingår lån av utrustning. Utrustningen ska vara i
                    samma skick när den återlämnas som den var när den lånades, tappar man bort något så får
                    man ersätta det.
                    Fallskärmen är packad när man lånar den och ska återlämnas packad.
                </p>
                <p>Fallskärmsutrustning är både dyrt och känsligt. Man hanterar alltid utrustningen med
                    respekt, den
                    ska rädda livet på en. Materialet slits eller skadas utav saker som exempelvis direkt
                    solljus,
                    lera/smuts, bensin, olja, onödigt slitage, eld (vi röker inte i närheten av utrustning).
                    Blir utrustningen blöt bör den hängas fritt inomhus så den torkar, och utsätts den för
                    saltvatten måste den sköljas av
                    med sötvatten innan den torkas.</p>
            </DocsIntro>
        </DocsHeader>
        <Section id="kring" name="Kringutrustning" >
            <SectionHeader>Kringutrustning</SectionHeader>
            <p>Vi börjar med att gå igenom den utrustning förutom fallskärm som behövs för att göra ett
                fallskärmshopp</p>
            <ul>
                <li><strong>Hjälm:</strong> skyddar huvudet mot stötar i flygplanet, i frifall och landning.
                </li>
                <li><strong>Goggles:</strong> skyddar ögonen från vindraget och ser till att du kan se i
                    frifall.</li>
                <li><strong>Höjdmätare:</strong> visar din höjd genom att känna av lufttrycket. Det är
                    höjden
                    som bestämmer hur du ska agera och veta när det är dags att dra fallskärmen.</li>
                <li><strong>Skor:</strong> lämpliga skor är stabila, skyddande, med tjock dämpande sula,
                    utan hyskor
                    och stödjer ankeln för att undvika ankelskador på de första landningarna.</li>
                <li><strong>Ankelstöd:</strong> bör användas om skorna inte ger stabilt ankelstöd.</li>
                <li><strong>Overall:</strong> bekväm i frifall och fladdrar inte framför handtag.</li>
                <li><strong>Handskar:</strong> förhindrar skrapsår om man trillar i landningen.</li>
            </ul>
            <Image image={utrustningIFrifall} imageSmall={utrustningIFrifallSmall} alt="Utrustning i frifall" />
            <p></p>
        </Section>
        <Section id="rigg" name="Rigg" >
            <SectionHeader>Rigg</SectionHeader>
            <p>Ett komplett fallskärmssystem kallas för <i>rigg</i>. Riggen ser ut som en ryggsäck
                kombinerad med en sele och innehåller två fallskärmar, <i>huvudfallskärmen</i> och
                <i>reservfallskärmen</i>.
                Selen består utav basremmar, benremmar samt en bröstrem. Basremmarna tar man på sig som
                axelbanden på en ryggsäck, benremmarna spänns runt benen och
                bröstremmen ser till att hopparen inte kan
                välta framåt ur selen. På framsidan sitter även ett losskopplingshandtag för
                huvudfallskärmen (så kallad <i>kutt</i>), <i>reservhandtag</i> och <i>kniv</i>. På baksidan
                finns <i>pilothandtaget</i>
                som används för att lösa ut huvudfallskärmen.
            </p>
            {/** <!--TODO bättre bild på rigg--> **/}
            <Image image={utrustningIPlanet} imageSmall={utrustningIPlanetSmall} alt="Utrustning i planet" />
            <p></p>
            <p>Delarnas funktion:
            </p>
            <ul>
                <li><strong>Tre-ring:</strong> sitter på basremmarna och är losskopplingssystem för
                    huvudfallskärmen. En på var basrem.
                    Kommer förklaras närmare i treringsavsnittet.</li>
                <li><strong>Basrem:</strong> strukturell del av selen.</li>
                <li><strong>Bröstrem:</strong> hindrar hopparen från att välta framåt ur selen. Träs i och
                    ur sitt spänne när man tar på och av remmen.</li>
                <li><strong>Kutt:</strong> losskopplingshandtag. Drar ut vajer som håller ihop treringarna.
                </li>
                <li><strong>Reservhandtag:</strong> handtag för att dra sprinten som håller inne
                    reservfallskärmen.</li>
                <li><strong>Kniv:</strong> för att i nödfall kunna kapa saker. T.ex. för att åtgärda en
                    felfunktion. Kommer diskuteras mer i felfunktioner-kapitlet.</li>
                <li><strong>Benrem:</strong> spänner fast hopparen. Spänns in och ut när man tar av och på
                    riggen.</li>
                <li><strong>Reserv</strong>-fallskärm<strong>:</strong> dra när huvudfallskärmen inte
                    fungerar.</li>
                <li><strong>Huvudfallskärm:</strong> den primära fallskärmen. Förklaras mer nedan.</li>
                <li><strong>Pilothandtag:</strong> handtaget till pilotfallskärmen (förklaras i kommande
                    text).</li>
            </ul>
            <Image image={riggIFrifall} imageSmall={riggIFrifallSmall} alt="Utrustning i frifall" />
            <br /><br />
            <Image image={bagOchPilot} imageSmall={bagOchPilotSmall} alt="Utrustning i planet" />
            <p>I riggen sitter en bag som kapslar in fallskärmen medan linorna löper och sedan släpper ut
                den.</p>
            <ul>
                <li><strong>Pilotfallskärm:</strong> den lilla fallskärmen som drar ut bag, linor och
                    huvudfallskärmen</li>
                <li><strong>Pilotlina:</strong> linan mellan bagen och pilotfallskärmen</li>
                <li><strong>Bag:</strong> en liten väska som håller inne fallskärmen tills linorna löpt ut.
                </li>
                <li><strong>Linor:</strong> bärlinor och styrlinor</li>
                <li><strong>Bärrem:</strong> anslutningen mellan linorna och tre-ringsfästet på riggen.</li>
            </ul>
            <p>Bilden nedan visar hur det ser ut under huvudskärmsfliken </p>
            <Image image={huvudflik} imageSmall={huvudflikSmall} alt="Utrustning i planet" />
            <ul>
                <li><strong>Sprint:</strong> håller ihop riggen till pilotlinan drar loss den från loopen
                    när pilotfallskärmen tar luft</li>
                <li><strong>Loop:</strong> Riggen hålls stängt utav ett snöre som från botten till toppen
                    trädd genom hål och en sprint överst. När sprinten dras löper snöret fritt och riggen
                    öppnar sig. Loopen går genom öljetter, metallförstärkta hålen i tyget på bilden. Idealt
                    byter man loopen när den ser sliten ut och inte när den redan gått av.</li>
            </ul>
            <p>Medan bagen löper ut linorna och släpper fallskärmen håller gummiband fast linorna i slag.
                Gummibanden går sönder efter några hopp och byts efter behov.</p>
            <Image image={bagGummiBand} imageSmall={bagGummiBandSmall} alt="Utrustning i planet" />
            <br />
            <br />
            <h3>Orange lapp</h3>
            <Image image={orangeLapp} imageSmall={orangeLappSmall} alt="Utrustning i planet" />
            <p> Fallskärmsjournal, är en orange lapp som dokumenterar komponenterna,
                deras serienummer och till vilket datum riggen är luftvärdig. Den innehåller också
                information om vem som packat reservfallskärmen. Den förvaras i en ficka i riggen. En rigg
                utan fallskärmsjournal får inte hoppas.</p>
        </Section>
        <Section id="fallskarm" name="Fallskärm" >
            <SectionHeader>Fallskärm</SectionHeader>
            <p>Moderna fallskärmar är formade som flygplansvingar och ger lyftkraft när den färdas genom
                luften. Den tar in luft från fartvinden i öppningar fram som blåser upp och ger den sin
                struktur.</p>
            {/** <!--<p>Moderna fallskärmar är aerodynamiskt formade som flygplansvingar och ges struktur utav
                            luftintag på framsidan.</p> --> **/}
            <p>De är konstruerade i längdgående sektioner kallade celler. Varje
                cell har två cellöppningar och mellan varje cell sitter linorna fast. Längst bak på
                fallskärmen i varje kan sitter styrlinorna fast. Våra elevfallskärmar har nio celler och är
                av typ <i><b>Navigator</b></i> från tillverkaren <i><b>Performance Designs</b></i>.</p>
            {/** <!-- TODO göra tydligare bild --> **/}
            <Image image={fallskarm} imageSmall={fallskarmSmall} alt="Utrustning i planet" />

            <p>(Bilden är på en sju-cellig fallskärm med kollapsad slider)</p>
            <ul>
                <li><strong>Framkant:</strong>, sidan med cellöppningar. Den sidan som är framåt i
                    färdriktningen.</li>
                <li><strong>Cell:</strong> längdgående sektion i fallskärmen I bilden enfärgade. Två
                    cellöppningar på framkanten.</li>
                <li><strong>Cellöppning:</strong> öppning som släpper in fartvinden som blåser upp och ger
                    fallskärmen sin form.</li>
                <li><strong>Undersida:</strong> sidan linorna sitter fast i.</li>
                <li><strong>Bakkant:</strong> där styrlinorna sitter fast i utkanterna. Bakåt i färdriktning
                </li>
                <li><strong>Bärlina:</strong> linor som inte är styrlinor. Bär hopparens vikt. Heter A, B,
                    C, D-bärlina från framkanten räknat.</li>
                <li><strong>Styrlina:</strong> linor mellan styrhandtagen och bakkanten</li>
                <li><strong>Bärrem:</strong> mellan linor och treringar</li>
                <li><strong>Styrhandtag:</strong> dra i för att styra via styrlinorna</li>
                <li><strong>Stabilisator:</strong> tyg som sticker ner på sidorna. Förbättrar
                    flygegenskaperna av fallskärmen.</li>
                <li><strong>Styrlinefäste:</strong> styrlinorna är de enda linorna som sitter fast i
                    bakkanten</li>
                <li><strong>Slider:</strong> fyller ingen vidare funktion när fallskärmen är öppnad. Den
                    används i öppningsförloppet enligt nedan.</li>
            </ul>
            <Image image={utlösningsförlopp} imageSmall={utlösningsförloppSmall} alt="Fallskärmen" />

            <p>En fallskärm i utlösningsförloppet (streaming)
            </p>
            <ul>
                <li><strong>Streamande fallskärm</strong>, en fallskärm i utlösningförlopp</li>
                <li><strong>Slider</strong>, håller ihop fallskärm tills hastigheten sänkts tillräckligt
                    för att fortsätta fallskärmen utlösningsförlopp.</li>
            </ul>
            <h3>Varningslapp</h3>
            <Image image={lapp} imageSmall={lappSmall} alt="Fallskärmen med varningslapp" />
            <Image image={varningslapp} imageSmall={varningslappSmall} alt="Varningslapp på fallskärm" />

            <p>Ovanpå fallskärmen sitter en liten lapp med en varning om att fallskärmshoppning är farligt.
                Den innehåller också information om fallskärmens typ, storlek, tillverkningsdag och
                serienummer.</p>
            <p>Vidare om flygegenskaperna hos en fallskärm kommer i det senare kapitlet <i>Under
                fallskärm</i>.</p>
            <p>En huvudskärm som har förblivit packad i sex månader skall packas om innan den får hoppas.
            </p>
        </Section>
        <Section id="trering" name="Trering" >
            <SectionHeader>Trering</SectionHeader>
            <p>Treringen är ett hävstångssystem för att lätt kunna koppa loss huvudfallskärmen. Den består
                utav en
                "ring" som sitter fast i riggen och två mindre ringar för utväxling som sitter på bärremmen.
                Där vardera av de mindre ringarna är var sin hävstång.
                De hålls på plats utav en loop som i sin tur hålls på plats utav en gul vajer från
                kutt-handtaget. Dras handtaget så dras vajern som släpper loopen och frigör bärremmarna från
                riggen. Detta gör det möjlig att med en hand och en rörelse koppla loss huvudfallskärmen.
                Skulle det sättas ihop fel så kan hävstångseffekten förloras och göra det svårt att koppla
                loss huvudfallskärmen.
            </p>
            <Image image={trering3} imageSmall={trering3Small} alt="Trering" />
            <Image image={trering2} imageSmall={trering2Small} alt="Trering" />
            <ul>
                <li><strong>Hard-housing:</strong> för att försäkra att kutt vajern aldrig kläms fast så man
                    inte kan dra den löper den inuti ett stålskydd.</li>
                <li><strong>RSL:</strong> förklaras vidare i underkapitlet <i>RSL</i> här i
                    utrustningskapitlet</li>
            </ul>
        </Section>
        <Section id="reserv" name="Reserv" >
            <SectionHeader>Reserv</SectionHeader>
            {/**<!-- TODO bättre bilder / mer bild på reserv som flyger.--> **/}
            <Image image={reservIfreebag} imageSmall={reservIfreebagSmall} alt="Reservdrag" />

            <p>Reserven, vår andra fallskärm sitter ovanför huvudfallskärmen i riggen. Den är snarlik
                huvudfallskärmen men med några skillnader:</p>
            <ul>
                <li><strong>Bagen sitter inte fast i fallskärmen:</strong> så att även om reservpiloten
                    fastnar i något kan fallskärmen ta sig loss. Tänk på att leta upp reservbagen om efter
                    du dragit reserv och landat.</li>
                <li><strong>Sju-cellig fallskärm:</strong> sportfallskärmar finns i både sju- och
                    nio-celliga designer. Reservens sju-celliga design innebär bättre chans till korrekt
                    öppning i utbyte mot något sämre flygförmåga.</li>
                <li><strong>Ett hål i slidern för att öppnas snabbare:</strong> för att säkerställa att den
                    hinner öppna om man är låg.</li>
                <li><strong>Fjäderladdad pilotfallskärm:</strong> som kan skjuta ut och dra ut
                    reservfallskärmen utan att hopparen gör något</li>
                <li><strong>Flyger sämre:</strong> design av fallskärm medför en massa kompromisser mellan
                    olika egenskaper, som tar sig långt eller rolig att flyga. Reserven har i alla sådana
                    fall valt det alternativ som ger störst sannolikhet för korrekt öppning.</li>
            </ul>
            <Image image={reservPilot} imageSmall={reservPilotSmall} alt="Reservpilot" />

            <p></p>
            <Image image={reservSprint} imageSmall={reservSprintSmall} alt="Reservflärp" />

            <p>Reserven får endast packas av en fallskärmskontrollant och har en plombering som bryts vid
                användning. En reservpackning är giltig upp till ett år om den besiktigas av
                fallskärmskontrollant efter sex månader. Annars tar den slut efter de sex månaderna
                passerat. Giltighetstid står på den orangea lappen. Har sista hoppdagen passerat är inte
                riggen luftvärdig och får inte hoppas.
            </p>
            <h3>Rapportering</h3>
            <p>Svenska fallskärmsförbundet har ett ansvar att rapportera händelser och kontinuerligt jobba
                med säkerhet i sporten från transportstyrelsen. För att göra det arbetet har vi som hoppare
                viss rapporteringsskyldighet mot förbundet.</p>
            <p>Det finns två rapporter man kan fylla i och lämna till sin CI som för det vidare till RI.</p>
            <ul>
                <li><strong>Röd rapport</strong>, fallskärmsrapport, "aj rapport", obligatorisk vid
                    reservdrag eller skador som leder till
                    uppsökande av sjukvård.</li>
                <li><strong>Blå rapport</strong>, händelseregistering, "oj rapport", för att lyfta något som
                    fick en att tänka oj även om det gick bra. Ett sätt att försöka lyfta något som kan vara
                    farligt innan en incident inträffar.</li>
            </ul>
            <p>Har man använt reserven ska man fylla i en röd rapport. Vet man inte vad eller hur att göra
                så förklarar hoppledaren, mer om det under <i>Flygfältet</i>, det. Att fylla i en röd
                rapport är ett krav.</p>

            <h3>När reservfallskärmen har behövts användas</h3>
            <p>När man använt sin fallskärm fokuserar man på att landa säkert. Efter man gjort det är nästa
                steg att hitta fallskärmen och freebagen man kopplat loss. Sannolikt har de drivit med
                vinden ganska långt. Man ber andra om hjälp om de sett något och om de kan hjälpa till att
                leta.</p>
            <p>Ser man någon annan drar reserven och man har möjlighet är det hjälpsamt att hålla koll på
                var den landar. Ju tydligare man kan förklara positionen mot riktmärken desto bättre.</p>
        </Section>
        <Section id="aad" name="AAD" >
            <SectionHeader>AAD</SectionHeader>
            <Image image={mergedLabel} imageSmall={mergedLabelSmall} alt="RSL" />

            <br /><br />

            <p>Räddningsutlösare, <i>Automatic Activation Device</i> (AAD). I alla riggar sitter en dator
                som
                löser ut reservfallskärmen ifall vissa kriterier är uppfyllda. Den gör det genom att med en
                liten krutladdning klippa av loppen som håller reservpiloten på plats.
                Kriterierna för att den ska lösa ut reserven motsvarar att en fallskärmshoppare fallit till
                för låg höjd utan att lösa ut sin fallskärm. Eventuellt på grund av medvetslöshet.</p>
            <p>
                Våra AADs är av modellen Cypress 2 från tillverkaren Airtech.
                Vi har två typer av cypresser i våra riggar. "Student", som identifieras av gul knapp. Den
                är alltid korrekt inställd.
                Och "changeable mode" som identifieras utav lila knapp. En changeable mode kan ställas om
                från student till expert. Efter den startats bör man kontrollera att den är i "Stu" (kort
                för student) läge.

                Utlösningskriterier för våra AADs är följande:</p>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th className="col w-25">Kriteriet</th>
                        <th scope="col">Scenario</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th className="theme-bg-light">35 m/s på 225m</th>
                        <td>(Frifallshastighet) Fallskärmshopparen är i frifall på sista höjden där reserven
                            kan hinna lösa ut.
                        </td>
                    </tr>
                    <tr>
                        <th className="theme-bg-light">13-34 m/s på 300m</th>
                        <td>(Felfunktionshastighet) Fallskärmshopparen har agerat något men inte
                            tillräckligt för att förhindra
                            sannolik död vid landning och sista höjden att hinna få ut mer tyg.</td>
                    </tr>
                </tbody>
            </table>
            <p>AADn måste startas på marken. Man trycker på knappen och sen trycker man <b>samtidigt</b> som
                lampan lyser. Därefter räknar den ner från tio och stannar på noll. Det är viktigt att detta
                görs på marken. Startar man den i flygplanet kan man lura cypressen att markhöjden är där man
                flyger och den kommer lösa ut på den höjden plus 225 m på vägen ner. En icke önskvärd situation.
                Inser man att man inte startat AAD när flygplanet har lyft får man helt enkelt landa med
                flygplanet.</p>
            <p>Enheten blir aktiv när den stigit förbi <b>450</b> meter över sin kalibrerade markhöjd.
                Hoppar man av lägre än så gör AADn inget.
            </p>
            <p>En cypress förblir aktiv <b>14</b> timmar från att den startats. Tillräckligt för att täcka
                en hel hoppdag. Efter 14 timmar stängs den av. Hittar man en rigg som är på kan den vara på
                sen dagen innan och det finns en risk att den stänger av sig. Lösningen är att starta om den
                och får 14 nya timmar. Vet man inte start man om den för säkerhets skull.
            </p>
            <h3>Om den används</h3>
            <p>Det är krav på att hoppa med AAD i Sverige och all utrustning du kommer använda under din
                utbildning kommer ha en AAD. Det förändrar inget med hur man beter sig i fallskärmshoppning.
                Ditt agerande i frifall ska utgå från att AADn inte fungerar eller är avstängd och göra
                allt i din makt för att rädda ditt liv själv. Får man inte tag i piloten för att dra sin
                huvudfallskärm försöker man igen. Hittar man den men får inte ut den tar man i hårdare.
                Lyckas man inte med sin huvudfallskärm drar man sin reserv. Slinter man på handtaget tar man
                tag igen. Tittar använder båda händer, tar av handskar eller sliter sönder kläder som
                hindrar en. Är AADn igång och räddar en så har man kommit undan en säker död. Det finns
                ingen höjd lägre än AADn löser ut reserven där man fortfarande hade kunnat rädda sig själv.
                En AAD räddning innebär ett omedelbart hoppstopp för individen och man kommer behöva genomgå
                en psykologiskt utvärdering innan man kan tillåta hoppas igen.</p>
            <p>Det händer då och då att personer oavsiktligt hoppar elev-AADs och gör kraftiga svängar på
                300m som leder till att reserven löses ut. Det leder till dubbla
                fallskärmar som vi kommer diskutera mer i felfunktioner kapitlet.</p>
        </Section>
        <Section id="rsl" name="RSL" >
            <SectionHeader>RSL</SectionHeader>
            <Image image={trering} imageSmall={treringSmall} alt="RSL" />

            <p>RSL är en förkortning för Reserve Static Line, statisk reserv lina. Det är en lina från
                bärremmen till reservsprinten. Dess funktion är att om bärremmarna lämnar riggen så ska
                reserven lösas ut. Det är ett komplement till att dra reservhandtaget efter man dragit
                kutt-handtaget och existerar för att få ut reserven snabbare. Det är beroende på att
                bärremmarna lämnar vilket endast händer som det finns något som drar it de när
                kutt-handtaget
                är draget. </p>
            <ul>
                <li><strong>RSL-hake</strong>, en liten skothake som kopplar till bärremmarna</li>
                <li><strong>RSL-ring</strong>, en liten ring på bärremmarna dedikerad till att fästa rsl-en
                    i
                </li>
                <li><strong>Flärp</strong>, dra i för att koppla loss rsl-en</li>
            </ul>
            <p>RSL sitter fast med en liten hake (specifikt en skothake) som går att koppla loss om man inte
                vill att reserven
                ska dras när huvudskärmen lämnar. Det vill man till exempel om man landat på ett tak och
                vill koppla loss huvudfallskärmen för att inte blåsa ner.</p>
            <h3>MARD</h3>
            <p>En vidareutveckling på RSL-systemet är Main Assisted Reserve Deployement (MARD) dessa system
                använder en ytterligare rem från RSL-en som är kopplad till reservpilotlinan. Det gör att om
                huvudfallskärmen kopplas loss och RSL-en drar reservsprinten så hjälper den även till att
                dra ut reservfallskärmen snabbare än vad reservpiloten hinner.</p>
        </Section>
        <Section id="brostrem" name="Bröstrem" >
            <SectionHeader>Bröstrem</SectionHeader>
            <Image image={frifall} imageSmall={frifallSmall} alt="Person i frifall" />

            <p>Bröstremmens funktion är att hindra att man trillar framåt ur selen. Den har ingen bärande
                funktion utöver det och man kan ibland se erfarna hoppare spänna upp den efter de hänger i
                sin fallskärm. Det är inget man ska göra om man inte har pratat med en erfaren instruktör
                först/ inget man ska göra.</p>
            <p>Bröstremmen är speciell i att man trär i och ur spännet för at ta av och på riggen. (Till
                skillnad från benremmarna man aldrig trär ur). Det här lilla avsnittet är bara för att visa
                hur man gör det rätt och hur det ser ut när det är fel.</p>
            <Image image={brostrem} imageSmall={brostremSmall} alt="Hur att trä bröstremmen" />

            <p>Korrekt trädd bröstrem. Genom spännet. Runt den lösa metalldelen. Genom spännet igen. Man ska
                också kunna känna att drar man i remmen så låser spännet.</p>

            <Image image={feltradd} imageSmall={feltraddSmall} alt="Hur att trä bröstremmen" />

            <p>En felträd bröstrem är bara träd en gång genom spännet och låser inte om man drar i remmen.
                Man håller ett öga på sig själv och andra att ingens bröstrem ser ut så. Skulle man inse i
                frifall att ens bröstrem är träd fel eller inte trädd all greppar man med sin vänstra hand
                runt basremmen tvärs över sin bröstkorg i höjd med bröstremmen. Kastar piloten med sin högra
                hand och sedan greppar tvärs över åt andra hållet med den. Väl under fallskärm kan man
                eventuellt trä i den igen. I frifall är det väldigt svårt att försöka få i och väldigt lätt
                att glömma bort höjden medan man sysslar med det.
            </p>
        </Section>
        <Section id="bromsar" name="Bromsar" >
            <SectionHeader>Bromsar/styrhandtag</SectionHeader>
            <Image image={lossa} imageSmall={lossaSmall} alt="Lossa styrhandtag" />

            <p>Styrhandtagen sitter fast i bärremmarna under utlösningsförloppet. De håller styrlinorna
                extra spända så fallskärmen flyger lugnt när den öppnar sig. När man lossar på de så drar
                man de neråt försiktigt ur sina fickor. Slacket löper ut och man kan då styra sin fallskärm.
                Se bilden ovan.
            </p>
            <p>När bromsarna är satta är handtaget trätt genom en ögla på styrlinan. Så kallat öga. Därefter
                sitter de med metallringen som avlastning och resårbandsfickor som håller de på plats.
                Bredvid eller bakom sitter hållare där överflödigt slack kan stoppas in.</p>
            <Image image={satta} imageSmall={sattaSmall} alt="Styrhandtag" />

            <p>För att "sätta" bromsarna efter man landat drar man linan så att ögat på linan är förbi
                metallringen. Därefter trär man handtaget genom ögat. Drat linan så att handtaget sitter mot
                det och stoppar in det i sina hållare. Efter det sätter man slacket på plats. som i första
                bilderna.</p>
            <p>När man landat sätter man bromsarna innan man samlar ihop sin fallskärm.</p>
        </Section>
        <Section id="elevriggar" name="Elevriggar" >
            <SectionHeader>Elevriggar</SectionHeader>
            <Image image={elevriggar} imageSmall={elevriggarSmall} alt="RSL" />
            <p>Under sin utbildning finns elevutrustningar att låna. De kännetecknas av sin färg och siffra
                på tejpen under reservfliken. På tejpen står även huvudskärmens storlek. Man lämnar tillbaka
                de i samma skick som man lånade de. Det vill säga: hel, ren, packad och komplett. Gör man
                inte det kommer man få betala för det man orsakat. Drar man reserven får man leta efter free
                bagen eller köpa en ny. Oftast när någon drar reserven hjälps vi åt för att hitta delarna.
                Landar man i lera får man göra rent den. packad och komplett är självförklarande.</p>
            <p>Våra elevriggar använder alla fallskärmar av typen Performance designs Navigator. De har
                dessa viktbegränsningar för givna storlekar. Exitvikt är den totala vikten av en fullt
                påklädd hoppare. Generellt är det nakenvikt plus tjugo kilo. Även om man viktmässigt får
                hoppa en fallskärm är det inte säkert att selen passar. Under utbildningen hjälper och
                kontrollerar instruktören att det blir rätt.</p>
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">Storlek på fallskärmen (sq.ft.)</th>
                        <th scope="col">Storlek på reserven (sq.ft.)</th>
                        <th scope="col">Max exitvikt (kg)</th>
                    </tr>
                </thead>
                <tbody>
                    {/**<!--<tr>
                                    <td>200</td>
                                    <td>64</td>
                                </tr>
                                <tr>
                                    <td>220</td>
                                    <td>80</td>
                                </tr> --> **/}
                    <tr>
                        <td>240</td>
                        <td>218</td>
                        <td>98</td>
                    </tr>
                    <tr>
                        <td>260</td>
                        <td>235</td>
                        <td>107</td>
                    </tr>
                    <tr>
                        <td>280</td>
                        <td>253</td>
                        <td>115</td>
                    </tr>
                    <tr>
                        <td>300</td>
                        <td>281</td>
                        <td>128</td>
                    </tr>
                </tbody>
            </table>
        </Section>
        <Section id="packcert" name="Packcert" >
            <SectionHeader>Packcert</SectionHeader>
            <p>Packcert är vad man kallar att en person har behörigheten fallskärmspackare. En
                fallskärmspackare får packa fallskärmar enligt tillverkares manualer och utföra kontroller
                på andra som packar. För att bli fallskärmspackare så ska man ha gjort 20 kontrollerade
                packningar, gått en materialkurs hos en fallskärmskontrollant och genomför en upppackning.
            </p>
            <p>Fallskärmspackarutbildning är uppdelad i två steg.</p>
            <h4>Steg ett</h4>
            <p>
                Första steget är en genomgång utav en
                av CI utsedd lägst hoppmästare få en genomgång utav fallskärmssystem och packningsteknik.
                Efter steg ett är man behörig att packa sin egen fallskärm utan kontroller.
            </p>
            <h4>Steg två</h4>
            <p>
                Består utav att man först övar packningar om sin egen fallskärm och läser på om
                utrustningen. Efter det skriver man ett skriftligt prov och reder ut en fallskärm som
                avsiktligt trasslats ihop. Redogör för samtliga kontroller inklusive en avslutande
                okulärbesiktning utav hela systemet.
            </p>
            <p>För att kunna få b-cert krävs att man är fallskärmspackare.</p>
        </Section>
        <Section id="sjalvkontroll" name="Självkontroll" >
            <SectionHeader>Självkontroll</SectionHeader>
            <p>En självkontroll eller självvisitering är att man ser över sin egen utrustning och ser att
                allt ser bra ut. Man gör den när man har sakerna på sig. Man gör en självkontroll innan man
                går på flygplanet och minst en gång i flygplanet. Självkontrollen består av att man kollar
                tre gånger tre saker.</p>
            <ol>
                <li>
                    <p>Tre remmar</p>
                    <ol>
                        <li>Ena benremmen</li>
                        <li>Andra benremmen</li>
                        <li>Bröstremmen</li>
                    </ol>
                </li>
                <li>
                    <p>Tre handtag</p>
                    <ol>
                        <li>Kutthandtaget</li>
                        <li>Reservhandtaget</li>
                        <li>Pilothandtaget</li>
                    </ol>
                </li>
                <li>
                    <p>Tre saker</p>
                    <ol>
                        <li>Hjälm</li>
                        <li>Goggles</li>
                        <li>Höjdmätare</li>
                    </ol>
                </li>
            </ol>
            <p>Har man någon i närheten kan man be de göra en "pin check" det innebär att de tittar så att
                reservsprinten och huvudskärmssprinten sitter som de ska. Man ber någon annan om hjälp iom
                man inte kan se de med riggen på.</p>
        </Section>
        <Section id="utrustning-quiz" name="Quiz" >
            <SectionHeader>Quiz, utrustning och material</SectionHeader>
            <Questionary 
                questions={materialQuiz}
            />
        </Section>
    </Article>
);

export {Material, materialQuiz};